// firebaseConfig.ts
// PURE CONFIG ONLY.
// Do not initialize Firebase here.
//
// Canonical Firebase clients live in:
//   src/lib/firebase.ts
//
// App/services/components should import:
//   auth, db, functions, storage
// from:
//   ./src/lib/firebase   // from App.tsx
//   ../lib/firebase      // from src/services or src/components

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};


export default firebaseConfig;